export default __webpack_public_path__ + "static/media/info_icon.6e369637.svg";